import Collapse from './Collapse';
export default Collapse;


//////////////////
// WEBPACK FOOTER
// /Users/shuai/Documents/github/ant-design-pro-site/scaffold/node_modules/_antd@3.15.2@antd/es/collapse/index.js
// module id = 592
// module chunks = 0